import * as React from 'react';
import { useState, useEffect, useRef } from "react";
import store from 'src/storeWire';
import { system_notification } from 'src/store/slice/system';
import { useQuoteFilterSelectionStore } from 'src/hooks/component/quote-filter-selection';
import produceClone from "../../../helper/produceClone";
import QuoteFilterSelection from './QuoteFilterSelection';
import Quote from "@system/config/quote";
import { useQuoteStore } from 'src/hooks/quote';
import Helper from 'src/support/Helper';

export function QuoteListingSearchFilter() {
    const [{ filter_list }, { }, { set_filter_list }] = useQuoteFilterSelectionStore();
    const [{ quoteReasonList }, { get_quote_reason_list }, { }] = useQuoteStore();

    const modal = {
        searchBy: '',
        searchVal: ''
    }
    const [searchModal, setSearchModal] = useState(modal);
    const [validation, setValidation] = useState({});

    useEffect(() => {
        // 11360
        async function fetchHere() {
            await get_quote_reason_list();
        }
        if (quoteReasonList && quoteReasonList?.length === 0)
            fetchHere();
    }, []);

    const ddlValues = [
        { id: "quoteNumber", text: "Quote Number" },
        { id: "manufacturerPartNumber", text: "Manufacturer Part Number" },
        { id: "customerPartNumber", text: "Customer Part Number" },
        { id: "quoteReasonType", text: "Quote Reason" }
    ];

    const onValueChange = (field, value) => {
        setSearchModal({ ...searchModal, [field]: value });
        setValidation({})
    }

    const onChangeSearchBy = (value) => {
        setSearchModal({ searchBy: value, searchVal: '' });
        setValidation({})
    }

    useEffect(() => {
        if (filter_list?.length <= 0) {
            setSearchModal(modal);
        }
    }, [filter_list])
    //validation pending

    const validateValue = () => {
        let _validation = {};
        let isValid = true;
        if (searchModal.searchBy === "") {
            _validation.searchBy = `Please select a "search by" option`;
            isValid = false;
        }

        if (Helper.valueIsNotNull(searchModal.searchVal)) {
            if (searchModal.searchVal.length < 3) {
                _validation.searchVal = "Please enter at least 3 characters to execute a keyword search "
                isValid = false;
            }
        } else {
            _validation.searchVal = "Search value is required"
            isValid = false;
        }

        setValidation(_validation)
        return isValid;
    }

    const onSearch = () => {
        const isValid = validateValue();
        if (!isValid) {
            return;
        }

        if (filter_list?.length > 0) {
            let seachIdx = filter_list.findIndex(f => f.searchKey === searchModal.searchBy)
            let list = produceClone(filter_list);

            if (seachIdx > -1) {
                list[seachIdx].searchKeyword = searchModal.searchVal.trim();
                set_filter_list(list)
            } else {
                let orderSearch = [{
                    searchKey: searchModal.searchBy,
                    searchType: ddlValues.find(f => f.id === searchModal.searchBy).text,
                    searchKeyword: searchModal.searchVal
                }]
                list = list.concat(orderSearch);
                set_filter_list(list)
            }
        } else {
            let list = [{
                searchKey: searchModal.searchBy,
                searchType: ddlValues.find(f => f.id === searchModal.searchBy).text,
                searchKeyword: searchModal.searchVal.trim()
            }];
            set_filter_list(list)
        }
    }



    return (
        <>
            <div className='sub-title mt-0'>My Submitted Quotes</div>
            <p className='mb-4'>Quotes that have been sent to the sales representative. Contains all your submitted online and offline quotes.</p>

            <div className="ps5 d-flex align-items-center mb-0 quote-tabs-links">
                <a href={Quote.getQuoteRouteURL()}>  My Open Quotes </a>
                <p className="ps5 text-black-stone mb-0 ms-1" >My Submitted Quotes</p>
            </div>
            <div className='quote-tabs-content'>
                <div className="d-flex align-items-top p-3">
                    <div>
                        <div className="dropdown quote-search-dd me-3">
                            <div className="selectbox">
                                <select className="form-control form-control-sm mr-3" aria-label="SearchBy"
                                    value={searchModal.searchBy}
                                    id="searchBy" onChange={(e) => {
                                        onChangeSearchBy(e.target.value)
                                    }}>
                                    <option value="">Search By</option>
                                    {ddlValues && (ddlValues).map((v, i) => (
                                        <option key={v.id} value={v.id}>{v.text}</option>
                                    ))}
                                </select>
                            </div>
                            <p className="error">{validation?.searchBy && validation.searchBy}</p>
                        </div>
                    </div>
                    <div className="w250">

                        <div className="bs5 input-group flex-nowrap">
                            {searchModal.searchBy === "quoteReasonType" ?
                                <div className="selectbox">
                                    <select className="form-control form-control-sm mr-3" id="quoteReasonType" value={searchModal.searchVal}
                                        onChange={(e) => { onValueChange('searchVal', e.target.value) }} >
                                        <option value="">Select a Quote Reason</option>
                                        {quoteReasonList && quoteReasonList.map((v, i) => (
                                            <option key={v.quoteReasonType} value={v.quoteReasonName}>{v.quoteReasonName}</option>
                                        ))}
                                    </select>
                                </div>
                                :
                                <input type="text" className="form-control form-control-sm" placeholder="Enter keyword, item, model or part number." id="searchVal"
                                    value={searchModal.searchVal} onChange={({ target: { value } }) => onValueChange('searchVal', value)} minLength={3} />
                            }

                            <a href={void (0)} className="bs5 btn btn-secondary d-flex align-items-center rounded-right-1" onClick={onSearch}><i className="fa fa-search text-black-stone"></i></a>
                        </div>
                        <p className="error">{validation?.searchVal && validation.searchVal}</p>
                        {/* <p className="error">{errors.searchVal?.type === 'required' && "Search value is required"}</p>
                    <p className="error">{errors.searchVal?.type === 'minLength' && "Please enter at least 3 characters to execute a keyword search "}</p> */}
                    </div>
                    <div className="bs5  m-1 p-1">
                        <a href={void (0)} data-toggle="modal" data-target="#delete-quote-Modal"
                            onClick={(e) => {
                                e.preventDefault();
                                store.dispatch(system_notification({
                                    name: 'QuoteAdvanceFilterPopup',
                                    data: [],
                                }));
                            }}>Advanced Filters</a>
                    </div>
                </div>
                <div className='px-3'>
                    <QuoteFilterSelection />
                </div>
            </div >
        </>
    );

}
